import React, { useState } from 'react';
import { useSendCodeMutation } from '../../redux/slices/emailApiSlice';
import styles from './EmailForm.module.css';
import { toast } from 'react-toastify';
import Logo from '../../assets/svgs/tevhidlogo.svg';

const EmailForm = ({ onNext }) => {
  const [email, setEmail] = useState('');
  const [sendCode, { isLoading }] = useSendCodeMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await sendCode({ email }).unwrap();
      toast.success('Doğrulama kodu gönderildi.');
      onNext(email);
    } catch (error) {
      toast.error('Email gönderimi başarısız.');
    }
  };

  return (
    <section className={styles.container}>
      <div className={styles.foregroundImage}>
        <div className={styles.auth}>
          <img src={Logo} alt="Logo" />
          <h1>Email giriniz</h1>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Gönderiliyor...' : 'Gönder'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EmailForm;
